import { render, staticRenderFns } from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=template&id=56bb7892&scoped=true"
import script from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=script&lang=js"
export * from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=style&index=0&id=56bb7892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb7892",
  null
  
)

export default component.exports